import { BaseComponent } from '../../types';
import { SecurityCard } from '../SecurityCard/SecurityCard';
import { useNavigate } from 'react-router-dom';

interface CyberSecuritySectionProps extends BaseComponent {}

export function CyberSecuritySection({ className }: CyberSecuritySectionProps) {
  const navigate = useNavigate();

  return (
    <section
      className={`w-full relative ${className || ''}`}
      style={{
        alignSelf: 'stretch',
        background: 'var(--Background, #020816)',
        paddingTop: '80px',
        paddingBottom: '80px',
      }}
    >
      {/* Eyebrow - positioned at top left */}
      <div
        className="absolute top-8 left-8"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--item-spacing-12, 12px)',
          zIndex: 10,
        }}
      >
        <div
          style={{
            width: '40px',
            height: '1px',
            background: 'var(--color-azure-69, #76BCE8)',
          }}
        />
        <span
          style={{
            color: 'var(--Cornflower, var(--color-azure-78, #9DD0F0))',
            fontFamily: 'var(--font-family-Font-3, Inter)',
            fontSize: 'var(--font-size-11, 11px)',
            fontStyle: 'normal',
            fontWeight: 'var(--font-weight-600, 600)',
            lineHeight: 'normal',
            letterSpacing: 'var(--letter-spacing-3, 3px)',
            textTransform: 'uppercase',
          }}
        >
          SİBER GÜVENLİK
        </span>
      </div>

      {/* Main content - divided vertically into two parts */}
      <div className="w-full px-8 flex justify-center">
        <div className="max-w-[1440px] w-full flex flex-col">
          {/* Top half */}
          <div className="min-h-[400px] flex flex-col lg:flex-row mb-4">
            {/* Top left */}
            <div className="w-full lg:w-2/5 m-2 rounded-lg flex flex-col justify-center lg:p-8">
              <h2
                style={{
                  fontFamily: 'Inter',
                  fontSize: 'clamp(32px, 8vw, 48px)',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: 'clamp(36px, 8vw, 50px)',
                  background:
                    'linear-gradient(91deg, #FBFBFB 23.66%, #E0FEFF 54.48%, #ADC4D2 69.34%, #3E90C3 97.54%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  marginBottom: '16px',
                }}
              >
                Kurumsal Seviyede
                <br />
                Siber Güvenlik
              </h2>
              <p
                style={{
                  color: '#FFF',
                  fontFamily: 'Inter',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '24px',
                  marginBottom: '24px',
                }}
              >
                CommerceMinder Security, pazaryeri altyapınızı ve dijital
                varlıklarınızı uçtan uca korumak için geliştirilmiş kapsamlı bir
                güvenlik yaklaşımı sunar.
              </p>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  alignSelf: 'stretch',
                  flexDirection: 'column',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    width: '100%',
                  }}
                >
                  <img
                    src="/icons/Check.svg"
                    alt="Check"
                    style={{ width: '16px', height: '16px', flexShrink: 0 }}
                  />
                  <span
                    style={{
                      color: '#FFF',
                      fontFamily: 'Inter',
                      fontSize: '16px',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: '24px',
                    }}
                  >
                    Sürekli izleme ile tehditler anlık tespit edilir
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    width: '100%',
                  }}
                >
                  <img
                    src="/icons/Check.svg"
                    alt="Check"
                    style={{ width: '16px', height: '16px', flexShrink: 0 }}
                  />
                  <span
                    style={{
                      color: '#FFF',
                      fontFamily: 'Inter',
                      fontSize: '16px',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: '24px',
                    }}
                  >
                    Olası risklere karşı proaktif koruma sağlanır
                  </span>
                </div>
              </div>
              <button
                onClick={() => navigate('/cyber-security')}
                className="transition-all duration-300 ease-in-out hover:bg-[#025BCF] hover:scale-105 hover:shadow-lg"
                style={{
                  display: 'flex',
                  padding: '12px 20px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '2px',
                  borderRadius: '24px',
                  border: '1.5px solid #025BCF',
                  background: 'transparent',
                  color: '#FFF',
                  fontFamily: 'Inter',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '24px',
                  marginTop: '24px',
                  cursor: 'pointer',
                  maxWidth: '290px',
                }}
              >
                Güvenlik Çözümlerimizi Keşfedin
              </button>
            </div>
            {/* Vertical line */}
            <div
              className="hidden lg:block"
              style={{
                width: '4px',
                height: '359px',
                background:
                  'linear-gradient(270deg, #020918 0.53%, #3E8FC3 54.6%, #2E6082 73.34%, #022844 84.71%, #071627 94.7%, #020816 109.19%)',
                alignSelf: 'center',
              }}
            />
            {/* Top right */}
            <div className="w-full lg:flex-1 m-2 rounded-lg flex items-center justify-center">
              <video
                src="/icons/code.mp4"
                autoPlay
                loop
                muted
                style={{
                  width: 'min(511px, 90vw)',
                  height: 'min(249px, 45vw)',
                  aspectRatio: '236/115',
                  borderRadius: '11px',
                  boxShadow: '0 4px 60px 0 rgba(73, 206, 255, 0.40)',
                }}
              />
            </div>
          </div>

          {/* Bottom half */}
          <div className="min-h-[400px] flex flex-col lg:flex-row">
            {/* Bottom left */}
            <div className="w-full lg:flex-1 m-2 rounded-lg flex flex-col justify-center items-center lg:items-start gap-4 p-4">
              {/* First row - left aligned */}
              <div className="flex justify-center lg:justify-start w-full">
                <SecurityCard
                  title="Veri Şifreleme"
                  statusLeft="encryption"
                  statusRight="active"
                />
              </div>
              {/* Second row - right aligned */}
              <div className="flex justify-center lg:justify-end w-full">
                <SecurityCard
                  title="Erişim Kontrolü"
                  statusLeft="access"
                  statusRight="verified"
                />
              </div>
              {/* Third row - left aligned */}
              <div className="flex justify-center lg:justify-start w-full">
                <SecurityCard
                  title="API Güvenliği"
                  statusLeft="api"
                  statusRight="protected"
                />
              </div>
              {/* Fourth row - right aligned */}
              <div className="flex justify-center lg:justify-end w-full">
                <SecurityCard
                  title="Gerçek Zamanlı İzleme"
                  statusLeft="monitoring"
                  statusRight="live"
                />
              </div>
            </div>
            {/* Bottom right */}
            <div className="w-full lg:flex-1 m-2 rounded-lg flex flex-col justify-center lg:p-8">
              <h2
                style={{
                  fontFamily: 'Inter',
                  fontSize: 'clamp(32px, 8vw, 48px)',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: 'clamp(36px, 8vw, 50px)',
                  background:
                    'linear-gradient(91deg, #FBFBFB 23.66%, #E0FEFF 54.48%, #ADC4D2 69.34%, #3E90C3 97.54%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  marginBottom: '16px',
                }}
              >
                Sistemlerinizi Kesintisiz
                <br />
                Güvende Tutun
              </h2>
              <p
                style={{
                  color: '#FFF',
                  fontFamily: 'Inter',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '24px',
                  marginBottom: '24px',
                }}
              >
                Proaktif güvenlik yaklaşımı ile riskleri önceden tespit edin,
                tehditlere anında müdahale edin ve iş sürekliliğinizi garanti
                altına alın.
              </p>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  alignSelf: 'stretch',
                  flexDirection: 'column',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    width: '100%',
                  }}
                >
                  <img
                    src="/icons/Check.svg"
                    alt="Check"
                    style={{ width: '16px', height: '16px', flexShrink: 0 }}
                  />
                  <span
                    style={{
                      color: '#FFF',
                      fontFamily: 'Inter',
                      fontSize: '16px',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: '24px',
                    }}
                  >
                    İş sürekliliğini kesintisiz koruyun
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    width: '100%',
                  }}
                >
                  <img
                    src="/icons/Check.svg"
                    alt="Check"
                    style={{ width: '16px', height: '16px', flexShrink: 0 }}
                  />
                  <span
                    style={{
                      color: '#FFF',
                      fontFamily: 'Inter',
                      fontSize: '16px',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: '24px',
                    }}
                  >
                    Güvenlik süreçlerini otomatik yönetin
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
